import { apiRequest } from "./client";

/**
 * NestJS leads contract (Part 72 §72.3):
 * - GET  /api/leads?q=&page=&size=        → { items, total, page, size }
 * - POST /api/leads                        → lead (409 on duplicate email/phone)
 * - PATCH /api/leads/:id                   → lead
 * - DELETE /api/leads/:id                  → 200
 * Lead wire is camelCase and already matches the legacy LeadResponseDto.
 * There is no /stats endpoint — stats are derived from the list (real data).
 */
const LIST_SIZE = 200;

function deriveStats(items) {
  const totalLeads = items.length;
  const qualifiedLeads = items.filter((lead) => Number(lead.status) === 3).length;
  const pipelineValue = items.reduce(
    (sum, lead) => sum + (Number(lead.estimatedValue) || 0),
    0
  );
  const conversionRatePercent = totalLeads
    ? Number(((qualifiedLeads / totalLeads) * 100).toFixed(1))
    : 0;

  return { totalLeads, qualifiedLeads, pipelineValue, conversionRatePercent };
}

export const leadsApi = {
  getAll: async (q) => {
    const params = new URLSearchParams({ page: "1", size: String(LIST_SIZE) });
    if (q?.trim()) params.set("q", q.trim());
    const data = await apiRequest(`/api/leads?${params}`);
    return (data?.items || []).map((lead) => ({
      ...lead,
      updatedAtUtc: lead.updatedAtUtc ?? lead.updatedAt ?? null,
    }));
  },
  getStats: async () => deriveStats(await leadsApi.getAll()),
  create: (payload) => apiRequest("/api/leads", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => apiRequest(`/api/leads/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  remove: (id) => apiRequest(`/api/leads/${id}`, { method: "DELETE" }),
};
